import React, { useEffect, useId, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import Check from '@mollie/ui-assets/icons/utilitarian/Check';
import { useDescendant, useDescendantsContextSelector } from '../Descandants';
import { ComboBoxDescendantsContext } from './ComboBox';
import { useComboBoxContext } from './ComboBoxContext';
import { onlyTextChildren, useComposedRefs } from '../../utils';
import { Icon } from '../Icon';
import { Checkbox } from '../Checkbox';
const typedMemo = React.memo;
export const ComboBoxItem = typedMemo(function ComboBoxItem(props) {
    var _a;
    const { children, prefix, value, index: indexProp, label = (_a = onlyTextChildren(children)) !== null && _a !== void 0 ? _a : (value ? String(value) : ''), onClick, className, disabled, } = props;
    const { onSelect, maybeClose, lastUsedKeyRef, multiselect } = useComboBoxContext();
    const id = useId();
    const [element, setElement] = useState(null);
    const descendant = useMemo(() => ({ element, value, id, label, disabled, prefix }), [element, value, id, label, disabled, prefix]);
    const index = useDescendant(descendant, ComboBoxDescendantsContext, indexProp);
    const itemRef = useRef(null);
    const composedItemRef = useComposedRefs(itemRef, setElement);
    const active = useDescendantsContextSelector(ComboBoxDescendantsContext, ({ activeIndex }) => activeIndex === index);
    const selected = useDescendantsContextSelector(ComboBoxDescendantsContext, ({ selected }) => selected.findIndex((descendant) => descendant.index === index) !== -1);
    const setActiveIndex = useDescendantsContextSelector(ComboBoxDescendantsContext, ({ setActiveIndex }) => setActiveIndex);
    useEffect(() => {
        if (active) {
            setTimeout(() => {
                var _a;
                return (_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }, 0);
        }
    }, [active]);
    const Element = multiselect && value != null ? Checkbox : 'div';
    const elementProps = Element === Checkbox
        ? {
            UNSAFE_labelRef: composedItemRef,
            UNSAFE_inputTabIndex: -1,
            checked: selected,
            onChange: () => {
                onSelect({ ...descendant, index });
            },
            disabled: disabled,
        }
        : { ref: composedItemRef };
    return (React.createElement(Element, { ...elementProps, role: "option", "aria-selected": Boolean(selected), className: clsx('mollie-ui-combo-box-item', {
            'mollie-ui-combo-box-item--active': active && lastUsedKeyRef.current != null,
        }, className), id: id, onClick: (e) => {
            e.stopPropagation();
            if (disabled)
                return;
            if (onClick) {
                onClick(value);
                maybeClose();
            }
            else if (!multiselect) {
                onSelect({ ...descendant, index });
            }
            setActiveIndex(index);
        }, onMouseMove: () => {
            setActiveIndex(index);
            lastUsedKeyRef.current = null;
        }, tabIndex: -1, "aria-disabled": disabled },
        prefix && (React.createElement("div", { className: "mollie-ui-combo-box-item-prefix" }, prefix)),
        React.createElement("div", { className: "mollie-ui-combo-box-item-content" }, children !== null && children !== void 0 ? children : label),
        !multiselect && selected && (React.createElement(Icon, { className: "mollie-ui-combo-box-item-check", src: Check }))));
});
ComboBoxItem.displayName = 'ComboBox.Item';
//# sourceMappingURL=ComboBoxItem.js.map